import React, { useState, useEffect } from 'react';
import axios from '../../../utils/axiosWithAuth';
import './SendEmailPage.css';
const SendEmailPage = () => {
  const [emailSubject, setEmailSubject] = useState('');
  const [emailBody, setEmailBody] = useState('');
  const [selectedEmails, setSelectedEmails] = useState([]);

  const [subscribers, setSubscribers] = useState([]);
  const [subSearch, setSubSearch] = useState('');
  const [subPage, setSubPage] = useState(1);
  const subsPerPage = 20;

  useEffect(() => {
    const fetchSubscribers = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/subscribers`);

        setSubscribers(res.data || []);
      } catch (err) {
        console.error('Failed to fetch subscribers:', err);
      }
    };
    fetchSubscribers();
  }, []);

  const toggleEmail = (email) => {
    setSelectedEmails((prev) =>
      prev.includes(email) ? prev.filter((e) => e !== email) : [...prev, email]
    );
  };

  const toggleSelectAll = () => {
    const currentEmails = filteredSubscribers.map((s) => s.email);
    if (selectedEmails.length === currentEmails.length) {
      setSelectedEmails([]);
    } else {
      setSelectedEmails(currentEmails);
    }
  };

  const sendEmail = async () => {
    try {
      await axios.post('/email/manual', {
        subject: emailSubject,
        message: emailBody,
        recipients: selectedEmails,
      });
      alert('✅ Email sent!');
      setEmailSubject('');
      setEmailBody('');
      setSelectedEmails([]);
    } catch (err) {
      alert('❌ Failed to send email.');
      console.error(err);
    }
  };

  const filteredSubscribers = subscribers.filter((s) =>
    s.email.toLowerCase().includes(subSearch.toLowerCase())
  );

  const paginatedSubscribers = filteredSubscribers.slice(
    (subPage - 1) * subsPerPage,
    subPage * subsPerPage
  );

  return (
    <div className="container my-4">
      <h4>📧 Send Email to Subscribers</h4>

      <input
        type="text"
        value={emailSubject}
        onChange={(e) => setEmailSubject(e.target.value)}
        placeholder="Enter subject"
        className="form-control my-2"
      />

      <textarea
        value={emailBody}
        onChange={(e) => setEmailBody(e.target.value)}
        placeholder="Write your message..."
        rows="4"
        className="form-control"
      />

      <button
        className="btn btn-success my-3"
        onClick={sendEmail}
        disabled={selectedEmails.length === 0}
      >
        📤 Send Email ({selectedEmails.length})
      </button>

      <div className="subscriber-list">
        <h5>📬 Select Recipients</h5>

        <input
          type="text"
          value={subSearch}
          onChange={(e) => {
            setSubSearch(e.target.value);
            setSubPage(1);
          }}
          placeholder="Search by email"
          className="form-control mb-2"
        />

        <button
          className="btn btn-sm btn-secondary mb-2"
          onClick={toggleSelectAll}
        >
          {selectedEmails.length === filteredSubscribers.length ? 'Unselect All' : 'Select All'}
        </button>

        <div className="email-list">
          {paginatedSubscribers.map((s, index) => (
            <div className="email-item" key={index}>
              <input
                type="checkbox"
                checked={selectedEmails.includes(s.email)}
                onChange={() => toggleEmail(s.email)}
              />
              <label>{s.email}</label>
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-between mt-3">
          <button
            className="btn btn-sm btn-outline-secondary"
            disabled={subPage === 1}
            onClick={() => setSubPage(subPage - 1)}
          >
            ⬅ Prev
          </button>
          <span>Page {subPage}</span>
          <button
            className="btn btn-sm btn-outline-secondary"
            disabled={subPage * subsPerPage >= filteredSubscribers.length}
            onClick={() => setSubPage(subPage + 1)}
          >
            Next ➡
          </button>
        </div>
      </div>
    </div>
  );
};

export default SendEmailPage;
